import { create } from 'zustand';
import type { App } from '../types/app.types';

interface AppStore {
  apps: App[];
  selectedApp: App | null;
  setApps: (apps: App[]) => void;
  setSelectedApp: (app: App | null) => void;
  addApp: (app: App) => void;
  removeApp: (appId: string) => void;
  updateAppOrder: (appId: string, newOrder: number) => void;
  reorderApps: (apps: App[]) => void;
}

export const useAppStore = create<AppStore>((set) => ({
  apps: [],
  selectedApp: null,
  setApps: (apps) => set({ apps }),
  setSelectedApp: (app) => set({ selectedApp: app }),
  addApp: (app) => set((state) => ({ apps: [...state.apps, app] })),
  removeApp: (appId) =>
    set((state) => ({
      apps: state.apps.filter((app) => app.id !== appId),
    })),
  updateAppOrder: (appId, newOrder) =>
    set((state) => ({
      apps: state.apps.map((app) => (app.id === appId ? { ...app, order: newOrder } : app)),
    })),
  reorderApps: (apps) => set({ apps }),
}));
